import { ApolloError, useMutation } from '@apollo/client';
import { EDIT_CRA_DAYS_MANUAL, GET_CRA_DAYS_MANUAL_EDIT_HISTORY } from '@bloomays-lib/adapter.api-bloomer';
import { CRADashboardItemGQL, EditCraDaysManualInput } from '@bloomays-lib/types.shared';

type EditCraDaysManualResult = {
  editCraDaysManual: CRADashboardItemGQL;
};

export const useEditCraDaysManual = () => {
  const [mutate, { loading, error }] = useMutation<EditCraDaysManualResult, { input: EditCraDaysManualInput }>(
    EDIT_CRA_DAYS_MANUAL,
    {
      context: { clientName: 'api.bloomers' },
      refetchQueries: (mutationResult) => {
        const activityId = mutationResult.data?.editCraDaysManual.activityId;
        if (!activityId) {
          return [];
        }
        return [
          {
            query: GET_CRA_DAYS_MANUAL_EDIT_HISTORY,
            variables: { craAirtableId: activityId },
            context: { clientName: 'api.bloomers' },
          },
        ];
      },
    },
  );

  const save = async (input: EditCraDaysManualInput): Promise<CRADashboardItemGQL> => {
    const response = await mutate({ variables: { input } });
    if (response.errors?.length) {
      throw new ApolloError({ graphQLErrors: response.errors });
    }
    if (!response.data?.editCraDaysManual) {
      throw new ApolloError({ errorMessage: 'editCraDaysManual returned no data' });
    }
    return response.data.editCraDaysManual;
  };

  return { save, loading, error };
};
